import api from '@/sui/api/api'

let module = null

const remote = true
if (remote) {
  module = {
    get (request) {
      return api.post('surveillance/explaur/get', request)
    },
    all (request) {
      return api.post('surveillance/explaur/all', request)
    }
  }
} else {
  module = {
  }
}

export default module
